import MainLayout from "screens/partials/layout";
import StorboltTeamListComponent from "screens/partials/team";

export default function TeamList() {
    return (
        <MainLayout>
            <StorboltTeamListComponent />
        </MainLayout>
    )
}